import { createSlice } from "@reduxjs/toolkit";
import { fetchPendingTask } from "./thunk";

interface MyTeamState {
  List: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: MyTeamState = {
  List: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const pendingTaskSlice = createSlice({
  name: "pendingTask",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingTask.fulfilled, (state, action) => {
        state.loading = false;
        state.List = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPendingTask.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Field Engineer Pending Task";
      });
  },
});

export default pendingTaskSlice.reducer;
